//JS Imports
import { windowIsSmallerThan, toggleDarkMode, getCookie, setCookie } from './helpers'
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Draggable } from 'gsap/Draggable';

gsap.registerPlugin(ScrollTrigger, Draggable);


jQuery(document).ready(function ($) {  
  $(document).on('click', '#mobile-menu-control-wrapper .menu-toggle', function() {
    if ( $('.mobile-menu-open').length > 0 ) {
            $('header.site-header').addClass("is-fixed");
    } else {
            $('header.site-header').removeClass("is-fixed");
    }
  });

  // Animate elements with the [animate-in] attribute
  gsap.utils.toArray('[animate-in]').forEach(ele => {
    // console.log(ele);
    const animation = ele.getAttribute('animate-in');
    const animatedSpeed = parseFloat(ele.getAttribute('animate-speed')) || 1;
    const animateDelay = parseFloat(ele.getAttribute('animate-delay')) || 0;

    const animations = {
      animate__flip: () => {
        gsap.set(ele, { y: 100, rotation: 0 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          y: 0,
          rotation: 360,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeIn: () => {
        // gsap.set(ele, { opacity: 0 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInUp: () => {
        gsap.set(ele, { y: 100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          y: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInDown: () => {
        gsap.set(ele, { y: -100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          y: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInLeft: () => {
        gsap.set(ele, { x: -100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          x: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInRight: () => {
        gsap.set(ele, { x: 100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          x: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      }
    }; 
  });


  if($(".single-post-share").length > 0) { 

    // if this reaches the top make it fixed to the bottom 80px 
    ScrollTrigger.create({
      trigger: ".single-post-share",
      start: "top top+=80",
      endTrigger: "body",
      end: "bottom bottom",
      toggleClass: {targets: ".single-post-share", className: "is-fixed"}
    });
  }

  if ($(".newsletter-sign-up-button").length > 0) {

    let newsLettterPopupButtonCookie = getCookie("ts-lp-newsletter-popup-button");
    if (newsLettterPopupButtonCookie == "hide") {
        return;
    }

    // Mobile only
    if (window.innerWidth <= 1080) {

      gsap.set(".newsletter-sign-up-button", {
          opacity: 0,
          y: 30,
          visibility: "hidden",
          pointerEvents: "none"
      });

      ScrollTrigger.create({
          start: 300,
          onEnter: () => {
              gsap.to(".newsletter-sign-up-button", {
                  opacity: 1,
                  visibility: "visible",
                  pointerEvents: "auto",
                  y: 0,
                  duration: 0.5,
                  ease: "power2.out",
              });
          },
          onLeaveBack: () => {
              gsap.to(".newsletter-sign-up-button", {
                  opacity: 0,
                  visibility: "hidden",
                  pointerEvents: "none",
                  y: 30,
                  duration: 0.5,
                  ease: "power2.in",
              });
          }
      });

    } else {
        $(".newsletter-sign-up-button")
            .css({ display: 'flex', opacity: 0, visibility: 'visible', pointerEvents: 'auto' })
            .animate({ opacity: 1 }, 500);
    }

    $(".newsletter-sign-up-button-open").on("click", function(e) {

        e.stopPropagation();
        let signUpForm = $('.newsletter-sign-up-form-popup');
        signUpForm.addClass("open");
        $('body').css('overflow', 'hidden');
    });
  }

  if ($(".newsletter-sign-up-button-remove").length > 0) {
    $(".newsletter-sign-up-button-remove").on("click", function(e){
      $(".newsletter-sign-up-button").fadeOut("slow");
      setCookie("ts-lp-newsletter-popup-button", "hide", 1);
    })
  }

  if ($(".newsletter-popup-close").length > 0) {
      $(".newsletter-popup-close").on("click", function(e){
          e.stopPropagation();
          let signUpForm = $('.newsletter-sign-up-form-popup');
          signUpForm.removeClass("open");
          signUpForm.find('.form-message').fadeOut();
          $('body').css('overflow', '');
      })
  }
  
  $(document).on('click', function(e) {
      if (!$(e.target).closest('.newsletter-sign-up').length && $('.newsletter-sign-up-form-popup').hasClass('open')) {
          let signUpForm = $('.newsletter-sign-up-form-popup');
          signUpForm.removeClass("open");
           signUpForm.find('.form-message').fadeOut();
          $('body').css('overflow', '');
      }
  });

  function fixCdkOverlayPointerEvents(isActive) {
      document.querySelectorAll('.cdk-overlay-backdrop').forEach(function (el) {
          el.style.pointerEvents = isActive ? '' : 'none';
      });
  }

  function changeZindex(isActive) {
      var newsletter = document.querySelector('.newsletter-sign-up-button');
      var aiAgent    = document.querySelector('.ai-agent');
      var header     = document.querySelector('.site-header');

      var defaultZ = isActive ? '1' : '3';
      var headerZ  = isActive ? '1' : '999';

      if (newsletter) newsletter.style.zIndex = defaultZ;
      if (aiAgent)    aiAgent.style.zIndex    = defaultZ;

      if (header) {
          header.style.zIndex = headerZ;
          if (isActive) {
              header.style.setProperty('transition', 'unset', 'important');
          } else {
              header.style.setProperty('transition', 'all 0.5s ease', 'important');
          }
      }

      fixCdkOverlayPointerEvents(isActive);
  }

  function onAngularBootstrapped(element) {

      var sidenavOpen = element.classList.contains('ts-sidenav-open');
      fixCdkOverlayPointerEvents(sidenavOpen);

      var sidenavObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
              if (mutation.attributeName === 'class') {
                  changeZindex(element.classList.contains('ts-sidenav-open'));
              }
          });
      });
      sidenavObserver.observe(element, { attributes: true });

      function watchCdkContainer() {
          var container = document.querySelector('.cdk-overlay-container');
          if (!container) return;
          fixCdkOverlayPointerEvents(element.classList.contains('ts-sidenav-open'));
          new MutationObserver(function () {
              fixCdkOverlayPointerEvents(element.classList.contains('ts-sidenav-open'));
          }).observe(container, { childList: true, subtree: true });
      }

      watchCdkContainer();

      if (!document.querySelector('.cdk-overlay-container')) {
          var bodyObserver = new MutationObserver(function (mutations, obs) {
              if (document.querySelector('.cdk-overlay-container')) {
                  obs.disconnect();
                  watchCdkContainer();
              }
          });
          bodyObserver.observe(document.body, { childList: true });
      }
  }

  function handleAppSearchEl(appSearchEl) {
      if (appSearchEl.hasAttribute('ng-version')) {
          onAngularBootstrapped(appSearchEl);
      } else {
          var ngBootstrapObserver = new MutationObserver(function (mutations) {
              mutations.forEach(function (mutation) {
                  if (mutation.attributeName === 'ng-version' && appSearchEl.hasAttribute('ng-version')) {
                      ngBootstrapObserver.disconnect();
                      onAngularBootstrapped(appSearchEl);
                  }
              });
          });
          ngBootstrapObserver.observe(appSearchEl, { attributes: true, attributeFilter: ['ng-version'] });
      }
  }

  function initAngularFix() {
      var appSearchEl = document.querySelector('.flight-widget app-search');
      
      if (appSearchEl) {
          handleAppSearchEl(appSearchEl);
          return;
      }

      // Element not in the DOM yet — wait for it to appear
      var elementObserver = new MutationObserver(function (mutations, obs) {
          var el = document.querySelector('.flight-widget app-search');
          
          if (el) {
              obs.disconnect();
              handleAppSearchEl(el);
          }
      });
      elementObserver.observe(document.body, { childList: true, subtree: true });
  }

  initAngularFix();

  if ($('.ts-hotel-wrapper').length > 0) {
    $('.hotel-list.carousel').each(function () {
      const root = this;
      let tries = 0;

      const wait = setInterval(function () {
        tries++;
        if ($(root).find('.hotel-card').length) {
          clearInterval(wait);
          initHotelCarousel($, root);
        } else if (tries > 50) {
          clearInterval(wait); // give up after ~10s
        }
      }, 200);
    });
  }
  
})

function initHotelCarousel($, rootEl) {
  const $root = $(rootEl);
  const $track = $root.find('.hotels-outer-wrapper > div').first();
  if (!$track.length || $root.data('carousel-ready')) return;
  if ($track.find('.hotel-card').length < 4) return;
  $root.data('carousel-ready', true);

  $track.addClass('ts-carousel-track');

  // Buttons live outside the Vue-mounted root so Vue can't remove them
   const $wrap = $root.wrap('<div class="ts-carousel-wrap"></div>').parent();
   const buttonSVG = `<svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.57271 9.01759C8.74935 8.99218 8.91346 8.91168 9.0417 8.78757L16.1127 1.99958C16.2015 1.9251 16.2741 1.83323 16.326 1.72964C16.3779 1.62604 16.4081 1.51291 16.4147 1.39721C16.4212 1.28151 16.404 1.16569 16.3641 1.05689C16.3242 0.948092 16.2625 0.848614 16.1827 0.764579C16.1029 0.680544 16.0067 0.613729 15.9001 0.568259C15.7935 0.52279 15.6788 0.499627 15.5629 0.50019C15.447 0.500752 15.3325 0.525038 15.2263 0.57154C15.1202 0.618042 15.0247 0.68577 14.9457 0.770576L8.4577 7.00259L1.9697 0.770576C1.89072 0.68577 1.79523 0.618042 1.68909 0.57154C1.58294 0.525038 1.46839 0.500752 1.35251 0.50019C1.23662 0.499627 1.12186 0.52279 1.01527 0.568259C0.908682 0.613729 0.812521 0.680544 0.732726 0.764579C0.652931 0.848614 0.591195 0.948092 0.551299 1.05689C0.511403 1.16569 0.494191 1.28151 0.500747 1.39721C0.507302 1.51291 0.537471 1.62604 0.5894 1.72964C0.64133 1.83323 0.713926 1.9251 0.802703 1.99958L7.8737 8.78757C7.96561 8.87604 8.07626 8.94266 8.19745 8.98247C8.31863 9.02229 8.44625 9.0343 8.57271 9.01759Z" fill="#A6B1C6" stroke="#A6B1C6"/>
    </svg>`
  const $prev = $(`<button type="button" class="ts-carousel-btn ts-carousel-prev" aria-label="Previous">${buttonSVG}</button>`).appendTo($wrap);
  const $next = $(`<button type="button" class="ts-carousel-btn ts-carousel-next" aria-label="Next">${buttonSVG}</button>`).appendTo($wrap);

  let index = 0, step = 0, maxIndex = 0, maxScroll = 0, draggable;

  const xFor = (i) => -Math.min(i * step, maxScroll);

  function measure() {
    const perView = window.innerWidth < 600 ? 1.5 : window.innerWidth < 992 ? 2 : 4;
    $root[0].style.setProperty('--per-view', perView);

    const cards = $track.find('.hotel-card');

    // Use real positions so the actual CSS gap (15px / 10px) is respected
    step = cards.length > 1
      ? cards[1].offsetLeft - cards[0].offsetLeft
      : cards[0].getBoundingClientRect().width;

    maxScroll = Math.max(0, $track[0].scrollWidth - $root[0].clientWidth);
    maxIndex = Math.ceil(maxScroll / step);
    index = Math.min(index, maxIndex);

    gsap.set($track[0], { x: xFor(index) });
    if (draggable) draggable.applyBounds({ minX: -maxScroll, maxX: 0 });
    updateButtons();
  }

  function goTo(i) {
    index = gsap.utils.clamp(0, maxIndex, i);
    gsap.to($track[0], { x: xFor(index), duration: 0.6, ease: 'power3.out' });
    updateButtons();
  }

  function updateButtons() {
    const canPrev = index > 0;
    const canNext = index < maxIndex;

    $prev.toggleClass('is-hidden', !canPrev).prop('disabled', !canPrev);
    $next.toggleClass('is-hidden', !canNext).prop('disabled', !canNext);
  }

  $prev.on('click', () => goTo(index - 1));
  $next.on('click', () => goTo(index + 1));

 draggable = Draggable.create($track[0], {
    type: 'x',
    edgeResistance: 0.85,
   onDrag() {
    const liveIndex = Math.round(-this.x / step);
    $prev.toggleClass('is-hidden', liveIndex <= 0);
    $next.toggleClass('is-hidden', -this.x >= maxScroll - 1);
  },
  onDragEnd() {
    goTo(Math.round(-this.x / step));
  },
  })[0];

  measure();

  let t;
  $(window).on('resize', () => {
    clearTimeout(t);
    t = setTimeout(measure, 150);
  });
}